import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { message } from 'antd';
import UserManagement from '../UserManagement';
import UserDetailDrawer from '../UserDetailDrawer';
import userService from '../../services/userService';
import { adminPath } from '../../../shared/config/paths';

/**
 * /users/:id —— 用户列表 + 直接打开该用户详情抽屉(命令面板、DNS 区域等处的用户链接)。
 * 关掉抽屉回到 /users。
 */
const UserDetailRoute = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
        let alive = true;
        setUser(null);
        userService.getUser(id)
            .then((res) => {
                if (!alive) return;
                const u = res?.data?.user || res?.data;
                if (res?.success && u && u.id) setUser(u);
                else message.error(res?.error || res?.message || '用户不存在');
            })
            .catch((e) => { if (alive) message.error(e?.error || e?.message || '加载用户失败'); });
        return () => { alive = false; };
    }, [id]);

    return (
        <>
            <UserManagement />
            <UserDetailDrawer
                visible={!!user}
                user={user}
                onClose={() => navigate(adminPath('/users'))}
                onChanged={() => {}}
            />
        </>
    );
};

export default UserDetailRoute;
